var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_toml") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.76,6.83v3.25h-5V25.17H14.26V10.08h-5V6.83Z",
    style: {
      fill: "#7f7f7f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,2H8.2V5.09H5.34v21.8H8.2V30H2Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,30H23.8V26.91h2.86V5.11H23.8V2H30Z",
    style: {
      fill: "#bfbfbf"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToml);
export default __webpack_public_path__ + "static/media/toml.e14a299f48cfc57a41ac8b3fda91d3d1.svg";
export { ForwardRef as ReactComponent };